/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { VoiceAiScreenerAnswerDto } from './VoiceAiScreenerAnswerDto';
import type { VoiceAiScreenerCallbackSchedulingDto } from './VoiceAiScreenerCallbackSchedulingDto';

export type VoiceAiScreenerWebhookDto = {
    referralId: string;
    status?: string;
    answers: Array<VoiceAiScreenerAnswerDto>;
    callSid?: string;
    phoneSessionId?: string;
    callbackScheduling?: VoiceAiScreenerCallbackSchedulingDto;
    outcome?: VoiceAiScreenerWebhookDto.outcome;
    endReason?: string;
    voiceAiPreference?: boolean;
}

export namespace VoiceAiScreenerWebhookDto {

    export enum outcome {
        COMPLETED = 'completed',
        DISCONNECTED = 'disconnected',
        SILENCE = 'silence',
        FAILED = 'failed',
    }


}
